import React, { useEffect, useState } from "react";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

const ApproveFromPoliceComplaint = ({ id, onSuccess }) => {
  const [laws, setLaws] = useState([]);
  const [selectedLawId, setSelectedLawId] = useState(null); // store as number
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Token & headers
  const rawToken = localStorage.getItem("token");
  const token = rawToken ? "Bearer " + rawToken.replace(/"/g, "") : null;
  const headers = {
    Authorization: token || "",
    "Content-Type": "application/json",
  };

  // Load laws
  useEffect(() => {
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Gabim!",
        text: "Seanca ka skaduar. Ju lutemi identifikohuni përsëri.",
        showConfirmButton: true,
      });
      return;
    }
    axios
      .get("/api/reports/laws", { headers })
      .then((res) => setLaws(res.data || []))
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: "Nuk mund të ngarkohen ligjet!",
          timer: 2500,
          showConfirmButton: true,
        });
      });
  }, [token]);

  const approve = async () => {
    if (!id) {
      Swal.fire({ icon: "error", title: "Gabim!", text: "Mungon ID e ankesës." });
      return;
    }
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Gabim!",
        text: "Seanca ka skaduar. Ju lutemi identifikohuni përsëri.",
      });
      return;
    }
    if (!selectedLawId) {
      setErrorMessage("Ju lutemi zgjidhni një ligj!");
      return;
    }

    setSubmitting(true);
    const baseUrl = `/api/complaints/approve-complaintPolice/${id}`;

    try {
      await axios.post(
        `${baseUrl}?lawId=${selectedLawId}`, // lawId as number
        {},
        { headers }
      );

      Swal.fire({
        icon: "success",
        title: "Sukses!",
        text: "Ankesa u aprovua me sukses.",
        timer: 1800,
        showConfirmButton: true,
        confirmButtonColor: "#18817d",
        confirmButtonText: "Mbyll",
      });

      setTimeout(() => {
        const chk = document.getElementById("my-modal-8");
        if (chk) chk.checked = false;
        onSuccess?.();
        setSubmitting(false);
      }, 500);
    } catch (err) {
      handleError(err);
      setSubmitting(false);
    }
  };

  const handleError = (err) => {
    const status = err?.response?.status;
    let msg = err?.response?.data?.message || "Diçka shkoi keq! Ju lutemi provoni përsëri.";
    if (status === 404) msg = "Ankesa nuk u gjet.";
    if (status === 409) msg = "Ankesa është aprovuar më parë.";
    Swal.fire({ icon: "error", title: "Gabim!", text: msg, showConfirmButton: true });
  };

  return (
    <>
      <input type="checkbox" id="my-modal-8" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl bg-white">
          <h3 className="flex justify-center pb-4 text-lg font-bold">
            Aprovimi i ankesës nga Policia
          </h3>
          <hr />

          <select
            className="select select-sm select-bordered w-full bg-white mt-4"
            value={selectedLawId ?? ""}
            onChange={(e) => {
              setSelectedLawId(parseInt(e.target.value, 10)); // convert to int
              setErrorMessage("");
            }}
            disabled={submitting}
          >
            <option value="" disabled>
              Zgjidh një ligj për të aprovuar ankesën:
            </option>
            {laws.map((law) => (
              <option key={law.id} value={law.id}>
                {law.name} - {law.price}€
              </option>
            ))}
          </select>

          {errorMessage && <div className="mt-2 text-sm text-red-500">{errorMessage}</div>}

          <footer className="modal-action">
            <label
              htmlFor="my-modal-8"
              className="btn-sm btn-circle btn absolute right-2 top-2"
              aria-label="Mbyll"
            >
              ✕
            </label>
            <label
              htmlFor="my-modal-8"
              className={`btn border-0 bg-white text-brand-700 hover:text-white ${
                submitting ? "pointer-events-none opacity-70" : ""
              }`}
            >
              Kthehu
            </label>
            <button
              onClick={approve}
              className="btn border-0 bg-brand-500 text-white hover:bg-brand-700"
              disabled={submitting}
            >
              {submitting ? "Duke aprovuar..." : "Dërgo"}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ApproveFromPoliceComplaint;
